import { Deserializable } from '../../../lib/models/deserializable';

export class ApplicantDependant implements Deserializable {
  public DependantID: number;
  public ApplicantNumber?: number;
  public Age?: number;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
